<template>
  <div id="container">
    <section id="mypage">
      <div class="wrap">
        <div class="cts_box">
          <h2 class="sub_ttl"><span>{{ withdrawalName() }}の{{ withdrawalWord() }}</span></h2>
          <p class="lead_txt">
            {{ withdrawalName() }}のご利用ありがとうございました。<br>
            以下の「{{ withdrawalWord() }}に関するアンケート」にお答えください。アンケートにお答えいただいた後に、
            <template v-if="isUserJoin()">
              「{{ withdrawalName() }}を{{ withdrawalWord() }}する」
            </template>
            <template v-else>
              「複眼経済塾の入塾をキャンセルする」
            </template>
            ボタンを押すと複眼経済塾からの{{ withdrawalWord() }}が完了します。<br>
          </p>
          <p class="lead_txt">
            <template v-if="isFreeUser()">
              <!-- ゲストユーザー向け-->
              {{ withdrawalWord() }}後には、マイページを含むすべてのコンテンツへのアクセスができなくなります。
            </template>
            <template v-else-if="isUserJoin()">
              <!-- 入塾者向け-->
              現在お支払いいただいている月謝充当期間の末日で正式に退塾となり、その後はマイページを含むすべてのコンテンツへのアクセスができなくなります。
            </template>
            <template v-else>
              <!-- 入塾待機者向け-->
              {{ withdrawalWord() }}後には、マイページを含むすべてのコンテンツへのアクセスができなくなります。
            </template>
          </p>
        </div>

        <div class="cts_box">
          <h3 class="min_ttl">{{ withdrawalWord() }}に関するアンケートにご協力ください</h3>
          <p class="lead_txt">
            {{ withdrawalWord() }}の理由を教えて下さい。今後の改善に活かしたいと存じます。<br>
            お手数をお掛け致しますが何卒よろしくお願い申し上げます。<br><br>
            {{ withdrawalWord() }}の理由を一つお選びください。
          </p>
          <form action="">
            <div class="input_set dropped_out">
              <div class="radio">
                <input id="radio01" type="radio" v-model="withdrawal_reason" value="withdrawal_reason_1">
                <label for="radio01">塾の講義内容が自分のイメージと合致しなかった</label>
              </div>

              <div class="radio">
                <input id="radio02" type="radio" v-model="withdrawal_reason" value="withdrawal_reason_2">
                <label for="radio02">塾の講義を十分に活かせなかった</label>
              </div>

              <div class="radio">
                <input id="radio03" type="radio" v-model="withdrawal_reason" value="withdrawal_reason_3">
                <label for="radio03">講義を見る時間的な余裕がなかった</label>
              </div>

              <div class="radio">
                <input id="radio04" type="radio" v-model="withdrawal_reason" value="withdrawal_reason_4">
                <label for="radio04">資金的な理由で継続が難しくなった</label>
              </div>

              <div class="radio">
                <input id="radio05" type="radio" v-model="withdrawal_reason" value="withdrawal_reason_5">
                <label for="radio05">他の投資スクールに入ることになった</label>
              </div>

              <div class="radio">
                <input id="radio06" type="radio" v-model="withdrawal_reason" value="withdrawal_reason_6">
                <label for="radio06">その他</label>
              </div>
              <div class="textarea" v-if="isFreeUser()">
                <textarea v-if="isUserJoin()" v-model="withdrawal_reason_text"
                          placeholder="退会理由について（自由にご記入ください）"></textarea>
                <textarea v-else v-model="withdrawal_reason_text"
                          placeholder="入会キャンセル理由について（自由にご記入ください）"></textarea>
              </div>
              <div class="textarea" v-else>
                <textarea v-if="isUserJoin()" v-model="withdrawal_reason_text"
                          placeholder="退塾理由について（自由にご記入ください）"></textarea>
                <textarea v-else v-model="withdrawal_reason_text"
                          placeholder="入塾キャンセル理由について（自由にご記入ください）"></textarea>
              </div>
              <p class="error_msg" v-if="error">必ず一つは選択してください。</p>
            </div>

            <div class="button_wrap" v-if="isFreeUser()">
              <p class="alnC sp_alnL mb10">アンケートに入力後にボタンを押してください。</p>

              <input type="button" class="submit arrow large light arrow" v-bind:value="withdrawalName() + 'を退会する'"
                     v-if="isUserJoin()" @click="membershipWithdrawal">
              <input type="button" class="submit arrow large light arrow" value="複眼経済塾の入会をキャンセルする"
                     v-else @click="membershipWithdrawal">
            </div>

            <div class="button_wrap" v-else>
              <p class="alnC sp_alnL mb10">アンケートに入力後にボタンを押してください。</p>

              <input type="button" class="submit arrow large light arrow" v-bind:value="withdrawalName() + 'を退塾する'"
                     v-if="isUserJoin()" @click="askMembershipWithdrawal">
              <input type="button" class="submit arrow large light arrow" value="複眼経済塾の入塾をキャンセルする"
                     v-else @click="membershipWithdrawal">
            </div>
            <div class="button_wrap">
              <p class="alnC sp_alnL mb10">{{
                  withdrawalWord()
                }}を希望されない方はこちらのボタンからマイページにお戻りください。</p>
              <router-link :to="{ name: 'UsersCustomerAccount'}" class="submit arrow large light skeleton arrow back">
                マイページに戻る
              </router-link>
            </div>
          </form>
        </div>

      </div>
    </section>

    <div class="modal open" v-if="show_modal">
      <div class="modal_box">
        <div class="header">
          <h4>複眼経済塾を退塾する</h4>
          <div class="close modal_close" v-on:click="show_modal = false"></div>
        </div>
        <div class="inner" style="text-align: center">
          <p class="red size24">
            本当に退塾しますか？ゲストユーザー（無料）として登録を残すことも可能です。
          </p>
          <p class="size12 mt20">
            ゲストユーザーになると現在の登録情報を利用してワークショップ申し込みや<br>
            動画レンタル・ショップ購入ができます。月謝の支払いはありません。<br>
            ゲストユーザーからの退会はいつでも可能です。
          </p>
          <div class="btn_wrap">
            <a href="javascript:void(0);" class="submit light"
               v-on:click="changeFreeUser()" style="max-width: 500px !important;">退塾してゲストユーザーになる</a>
          </div>
          <div class="btn_wrap">
            <a href="javascript:void(0);" class="submit light"
               v-on:click="membershipWithdrawal()" style="max-width: 500px !important;">完全に退塾する</a>
          </div>
          <div class="btn_wrap">
            <a href="javascript:void(0);" class="submit gray modal_close"
               v-on:click="show_modal = false" style="max-width: 500px !important;">キャンセル</a>
          </div>
        </div>
      </div>
      <div class="ovr"></div>
    </div>

  </div>
</template>

<script>

import Libraries from '@/components/Libraries'

export default {
  mixins: [Libraries],
  data() {
    return {
      withdrawal_reason: null,
      withdrawal_reason_text: null,
      error: false,
      show_modal: false,
      change_free_user: false
    }
  },
  methods: {
    mounted() {
      if (!this.isUserJoin()) {
        this.$router.push({name: 'UsersCustomerWithdrawalNoJoin'})
      }
    },
    askMembershipWithdrawal() {
      if (!this.withdrawal_reason) {
        this.error = true
        return
      }
      this.show_modal = true
    },
    changeFreeUser() {
      this.show_modal = false
      this.change_free_user = true
      this.membershipWithdrawal()
    },
    membershipWithdrawal() {
      this.show_modal = false
      if (!this.withdrawal_reason) {
        this.error = true
        return
      }
      this.error = false
      if (this.change_free_user) {
        if (!confirm('ゲストユーザーへの変更申請を実施しますか？')) {
          return
        }
      } else {
        if (!confirm(`${this.withdrawalWord()}の申請を実施しますか？`)) {
          return
        }
      }
      this.axios
          .post((this.change_free_user ?
              `${this.env.api_base_url}users/change_rank_free_request.json` :
              `${this.env.api_base_url}users/membership_withdrawal.json`), {
            user: {
              withdrawal_reason: this.withdrawal_reason,
              withdrawal_reason_text: this.withdrawal_reason_text
            },
          })
          .then(response => {
            // console.log(response.data)
            if (this.change_free_user) {
              const message = `ゲストユーザーへの変更申請を受け付けました。\n実際にゲストユーザーへと移行するのは、${this.moment(response.data.change_rank_at, 'YYYY年MM月DD日')} となります。\nマイページへ戻ります。`
              alert(message)
              // マイページへ
              this.$router.push({name: 'UsersCustomerAccount'})
            } else if (!response.data.withdrawal_at) {
              const message = `退塾の申請を受理出来ませんでした。\n事務局までお問い合わせください。\nマイページへ戻ります。`
              alert(message)
              // マイページへ
              this.$router.push({name: 'UsersCustomerAccount'})
            } else if (!response.data.status === 'status_withdrawal') {
              // TOPへ
              alert('入塾キャンセル手続きが完了いたしました。\n機会がございましたら、またのご利用をお待ちしております。\nTOPページへ戻ります。')
              this.removeSession();
              location.href = '/'
            } else if (this.isFreeUser()) {
              alert('退塾の申請を受け付けました。')
              this.removeSession();
              location.href = '/'
            } else {
              const message = `退塾の申請を受け付けました。\n実際に退塾へと移行するのは、${this.moment(response.data.withdrawal_at, 'YYYY年MM月DD日')} となります。\nマイページへ戻ります。`
              alert(message)
              // マイページへ
              this.$router.push({name: 'UsersCustomerAccount'})
            }
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
          })
    },
    withdrawalWord() {
      if (this.isFreeUser()) {
        return '退会'
      } else if (this.isUserJoin()) {
        return '退塾'
      } else {
        return '入塾キャンセル'
      }

    },
    withdrawalName() {
      return this.isFreeUser() ? 'ゲストユーザー' : '複眼経済塾'
    }
  }
}
</script>
